import { useState } from "react";

import type { SavedJobState } from "../../../../../../__generated__/types.gqlgenerated";
import type { SaveButtonSyncState } from "../../../../../../shared/native-modules/tare/savedJobStateChangedEvent";
import { useUpdateSavedJobStateMutation } from "./__generated__/SaveJobButton.gqlgenerated";

export type ToggleResult = {
  readonly state: SaveButtonSyncState;
  readonly isSaved: boolean;
};
export type Toggle = (currentState: SavedJobState | null | undefined) => Promise<ToggleResult>;
export type Status = "fatal" | "idle" | "active" | "success" | "error";
export interface SaveJobAction {
  toggle: Toggle;
  status: Status;
}

function createToggleResult(state: SaveButtonSyncState): ToggleResult {
  return {
    state,
    get isSaved() {
      return state === "SAVED";
    },
  };
}

export default function useToggleSaveJob(jobKey: string): SaveJobAction {
  const [commit] = useUpdateSavedJobStateMutation();
  const [status, setStatus] = useState<Status>("idle");
  const toggle = async (currentState: SavedJobState | null | undefined) => {
    const state: SaveButtonSyncState = currentState === "SAVED" ? "VISITED" : "SAVED";
    try {
      setStatus("active");
      await commit({
        variables: {
          jobKey,
          state,
        },
      });
      setStatus("success");
      return createToggleResult(state);
    } catch (err) {
      setStatus("error");
      throw err;
    }
  };

  return {
    toggle,
    status,
  };
}
